import type { DeviceManifest } from '@rapoo/device-sdk'
import {
  baseChannel0To7,
  baseChildDeviceEnabled,
  createBaseScreenImageCapability,
  inputReportRetail,
} from './generate/capabilityPresets'
import { p8BaseLightBandEffects } from './generate/lightingPresets'

/**
 * VPR8PLUS 底座设备清单
 */
const rapooVPR8PLUS: DeviceManifest = {
  channel: ['global'],
  model: 'VPR8 PLUS',
  mainControl: 'VPR8 PLUS',
  type: 'base',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: 0x144d,
    currentPid: 0x144d,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 14,
        description: 'Base WebHID Command Interface',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 2,
        description: 'Base Nordic Firmware Update Interface',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Base WCH Firmware Update Interface',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L_Base',
  baseDisplay: 'screen',
  ui: {
    assetsDir: 'manifests/VPR8 PLUS',
    colors: {
      series: [
        {
          name: 'common.products.VPR8_PLUS.Black',
          value: '#2B2B2B',
          key: 'Black',
        },
      ],
      current: 'Black',
    },
    icon: 'Hardware-Wireframe-Base',
    overview: true,
  },
  capabilities: [
    inputReportRetail,
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: p8BaseLightBandEffects,
      },
    },
    createBaseScreenImageCapability({
      maxScreenSlots: 8,
      systemPages: [
        {
          slot: 0,
          kind: 'home',
          presetScreens: [
            { style: 0, asset: 'preset1.png' },
            { style: 1, asset: 'preset2.png' },
            { style: 2, asset: 'preset3.png' },
          ],
        },
      ],
    }),
    baseChannel0To7,
    baseChildDeviceEnabled,
  ],
  layout: {
    image: 'devices/base/base.png',
    keys: [],
  },
}

export default rapooVPR8PLUS
